import { BASE_URL } from './env'

export const ACCOUNT_SUBDOMAIN = 'account'

/**
 * Dynamic route segment name for the product parameter.
 * Matches the `[product]` folder under `src/app/(index)/`.
 */
export const PRODUCT_ROUTE_PARAM = 'product'

export const CONVERSATION_THREAD_ID_ROUTE_PARAM = 'threadId'

// Reserved subdomain that serves ONLY the public, embeddable chart renderer (e.g. charts.shalion.com,
// charts.localhost). It carries no account context and is exempt from the account/auth proxy logic.
export const CHART_SUBDOMAIN = 'charts'

export const routes = {
  alerts: '/alerts',
  account: '/select-account',
  chartRenderer: '/render',
  healthCheck: '/health-check',
  generatedChromium: '/chromium-pack.tar',
  login: '/login',
  mcpLogin: '/mcp-login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  updatePassword: '/update-password',
  index: '/',
  myPreferences: '/my-preferences',
  noProducts: '/no-products',
  templates: '/slides/templates',
}

export const urls = {
  account: `https://${ACCOUNT_SUBDOMAIN}.${BASE_URL}${routes.account}`,
}
